var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRandomIcon = function SvgRandomIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.818,
    height: 29.267,
    viewBox: "0 0 33.818 29.267",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 9.103, 4.247)",
    fill: "none",
    stroke: "#5a6798",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22.896,
    height: 22.896,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 6.185)",
    fill: "#fff",
    stroke: "#5a6798",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.896,
    height: 23.896,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22.896,
    height: 22.896,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 2.276,
    cy: 2.276,
    r: 2.276,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 11.199, 23.8)",
    fill: "#5a6798"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.276,
    cy: 2.276,
    r: 2.276,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 18.893, 21.738)",
    fill: "#5a6798"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.276,
    cy: 2.276,
    r: 2.276,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 9.727, 18.304)",
    fill: "#5a6798"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.276,
    cy: 2.276,
    r: 2.276,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 17.421, 16.242)",
    fill: "#5a6798"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.276,
    cy: 2.276,
    r: 2.276,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 8.254, 12.808)",
    fill: "#5a6798"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.276,
    cy: 2.276,
    r: 2.276,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 15.948, 10.747)",
    fill: "#5a6798"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRandomIcon, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMy44MTgiIGhlaWdodD0iMjkuMjY3IiB2aWV3Qm94PSIwIDAgMzMuODE4IDI5LjI2NyI+DQogIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiPg0KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDAuOTk5LCAtMC4wMzUsIDAuMDM1LCAwLjk5OSwgOS4xMDMsIDQuMjQ3KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNWE2Nzk4IiBzdHJva2Utd2lkdGg9IjEiPg0KICAgICAgPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIyMi44OTYiIGhlaWdodD0iMjIuODk2IiByeD0iMS41IiBmaWxsPSJub25lIi8+DQogICAgPC9nPg0KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDAuOTY2LCAtMC4yNTksIDAuMjU5LCAwLjk2NiwgMCwgNi4xODUpIiBmaWxsPSIjZmZmIiBzdHJva2U9IiM1YTY3OTgiIHN0cm9rZS13aWR0aD0iMSI+DQogICAgICA8cmVjdCB3aWR0aD0iMjMuODk2IiBoZWlnaHQ9IjIzLjg5NiIgcng9IjIiIHN0cm9rZT0ibm9uZSIvPg0KICAgICAgPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIyMi44OTYiIGhlaWdodD0iMjIuODk2IiByeD0iMS41IiBmaWxsPSJub25lIi8+DQogICAgPC9nPg0KICAgIDxjaXJjbGUgY3g9IjIuMjc2IiBjeT0iMi4yNzYiIHI9IjIuMjc2IiB0cmFuc2Zvcm09Im1hdHJpeCgtMC4yNTksIC0wLjk2NiwgMC45NjYsIC0wLjI1OSwgMTEuMTk5LCAyMy44KSIgZmlsbD0iIzVhNjc5OCIvPg0KICAgIDxjaXJjbGUgY3g9IjIuMjc2IiBjeT0iMi4yNzYiIHI9IjIuMjc2IiB0cmFuc2Zvcm09Im1hdHJpeCgtMC4yNTksIC0wLjk2NiwgMC45NjYsIC0wLjI1OSwgMTguODkzLCAyMS43MzgpIiBmaWxsPSIjNWE2Nzk4Ii8+DQogICAgPGNpcmNsZSBjeD0iMi4yNzYiIGN5PSIyLjI3NiIgcj0iMi4yNzYiIHRyYW5zZm9ybT0ibWF0cml4KC0wLjI1OSwgLTAuOTY2LCAwLjk2NiwgLTAuMjU5LCA5LjcyNywgMTguMzA0KSIgZmlsbD0iIzVhNjc5OCIvPg0KICAgIDxjaXJjbGUgY3g9IjIuMjc2IiBjeT0iMi4yNzYiIHI9IjIuMjc2IiB0cmFuc2Zvcm09Im1hdHJpeCgtMC4yNTksIC0wLjk2NiwgMC45NjYsIC0wLjI1OSwgMTcuNDIxLCAxNi4yNDIpIiBmaWxsPSIjNWE2Nzk4Ii8+DQogICAgPGNpcmNsZSBjeD0iMi4yNzYiIGN5PSIyLjI3NiIgcj0iMi4yNzYiIHRyYW5zZm9ybT0ibWF0cml4KC0wLjI1OSwgLTAuOTY2LCAwLjk2NiwgLTAuMjU5LCA4LjI1NCwgMTIuODA4KSIgZmlsbD0iIzVhNjc5OCIvPg0KICAgIDxjaXJjbGUgY3g9IjIuMjc2IiBjeT0iMi4yNzYiIHI9IjIuMjc2IiB0cmFuc2Zvcm09Im1hdHJpeCgtMC4yNTksIC0wLjk2NiwgMC45NjYsIC0wLjI1OSwgMTUuOTQ4LCAxMC43NDcpIiBmaWxsPSIjNWE2Nzk4Ii8+DQogIDwvZz4NCjwvc3ZnPg0K";
export { ForwardRef as ReactComponent };